class TrackMyOrderController {
    constructor(settings, shopperService, storeService, orderInformationService) {
        this.settings = settings;
        this.shopperService = shopperService;
        this.storeService = storeService;
        this.orderInformationService = orderInformationService;
    }

    $onChanges(data) {
        if (!data.tmoInfo || data.tmoInfo && !data.tmoInfo.currentValue) return;

        this.orderWarningMessage = this.orderInformationService.getWarningMessage({
            order: this.tmoInfo,
            deliveryMethod: this.tmoInfo.DeliveryMethod,
        });

        this.updateStore();
    }

    updateStore() {
        this.store = this.tmoInfo && this.tmoInfo.DeliveryMethod === this.settings.trackMyOrderDeliveryMethod.pickup
            ? this.tmoInfo.Store
            : undefined;
        if (!this.store) return;

        this.url = this.storeService.getStoreUrl(this.store);
    }

    getPickupMessageSetting() {
        return this.shopperService.shopper.EmailOptIn
            ? 'pickupMessageWithEmailInfo'
            : 'pickupMessage';
    }
}

TrackMyOrderController.$inject = ['Settings', 'ShopperService', 'StoreService', 'OrderInformationService'];

const trackMyOrderComponentDefinition = {
    controller: TrackMyOrderController,
    template: require('./track-my-order.component.html').trim(),
    bindings: {
        tmoInfo: '<',
    },
};

module.exports = {
    TrackMyOrderController,
    trackMyOrderComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/trackmyorder/track-my-order.component.js